import React from "react";
import constant from "../../../../constants";
import { FormInput, FormSelect, SectionTitle } from "./FormField";

export const OrderBuyFor = ({
  orderInfo,
  setOrderInfo,
  updateValue,
  loading,
}) => {
  if (!orderInfo?.isBuyForSomeoneElse) return null;

  return (
    <div>
      <SectionTitle title="ซื้อให้บุคคลอื่น" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <FormInput
          label="ชื่อผู้รับ"
          disabled={loading}
          value={orderInfo?.buyFor?.firstName || ""}
          onChange={(e) =>
            setOrderInfo((prev) => ({
              ...prev,
              buyFor: { ...prev.buyFor, firstName: e.target.value },
            }))
          }
          onBlur={(e) => updateValue("buyFor.firstName", e.target.value)}
        />

        <FormInput
          label="นามสกุลผู้รับ"
          disabled={loading}
          value={orderInfo?.buyFor?.lastName || ""}
          onChange={(e) =>
            setOrderInfo((prev) => ({
              ...prev,
              buyFor: { ...prev.buyFor, lastName: e.target.value },
            }))
          }
          onBlur={(e) => updateValue("buyFor.lastName", e.target.value)}
        />

        <FormInput
          label="เบอร์โทรศัพท์ผู้รับ"
          disabled={loading}
          value={orderInfo?.buyFor?.phone || ""}
          onChange={(e) =>
            setOrderInfo((prev) => ({
              ...prev,
              buyFor: { ...prev.buyFor, phone: e.target.value },
            }))
          }
          onBlur={(e) => updateValue("buyFor.phone", e.target.value)}
        />

        <FormSelect
          label="ธนาคารผู้รับ"
          disabled={loading}
          value={orderInfo?.buyFor?.bank || ""}
          onChange={(e) => updateValue("buyFor.bank", e.target.value)}
        >
          <option value="">-</option>
          {constant.bankList.map((bank) => (
            <option key={bank.bankName} value={bank.bankName}>
              {bank.bankName}
            </option>
          ))}
        </FormSelect>

        <FormInput
          label="ชื่อบัญชีธนาคารผู้รับ"
          disabled={loading}
          value={orderInfo?.buyFor?.accName || ""}
          onChange={(e) =>
            setOrderInfo((prev) => ({
              ...prev,
              buyFor: { ...prev.buyFor, accName: e.target.value },
            }))
          }
          onBlur={(e) => updateValue("buyFor.accName", e.target.value)}
        />

        <FormInput
          label="เลขบัญชีธนาคารผู้รับ"
          disabled={loading}
          value={orderInfo?.buyFor?.accNo || ""}
          onChange={(e) =>
            setOrderInfo((prev) => ({
              ...prev,
              buyFor: { ...prev.buyFor, accNo: e.target.value },
            }))
          }
          onBlur={(e) => updateValue("buyFor.accNo", e.target.value)}
        />
      </div>
    </div>
  );
};
